import React from 'react';
import { swarm_yellow } from './colors';
import PacmanLoader from 'react-spinners/PacmanLoader';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';
import ClockLoader from 'react-spinners/ClockLoader';
import RiseLoader from 'react-spinners/RiseLoader';
import HashLoader from 'react-spinners/HashLoader';
import GridLoader from 'react-spinners/GridLoader';

function LoadingSpinner(props: { type: 'pacman' | 'boxlader' | 'clock' | 'rise-loader' | 'hash' | 'grid' }) {
	return (
		<div
			style={{
				position: 'fixed',
				top: '50%',
				left: '50%',
				marginTop: '-50px',
				marginLeft: '-100px',
				background: 'white'
			}}
		>
			<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
				<img
					src={
						'https://firebasestorage.googleapis.com/v0/b/swarmob-4371c.appspot.com/o/general%2Fswarmob.png?alt=media&token=7073f5e5-7360-415b-a6c9-418231872b66'
					}
					alt="swarmob"
					height="100px"
				/>
				<br />
				{props.type === 'pacman' && <PacmanLoader size={40} color={swarm_yellow}></PacmanLoader>}
				{props.type === 'boxlader' && <ClimbingBoxLoader size={20} color={swarm_yellow}></ClimbingBoxLoader>}
				{props.type === 'clock' && <ClockLoader size={20} color={swarm_yellow}></ClockLoader>}
				{props.type === 'rise-loader' && <RiseLoader size={20} color={swarm_yellow}></RiseLoader>}
				{props.type === 'hash' && <HashLoader size={20} color={swarm_yellow}></HashLoader>}
				{props.type === 'grid' && <GridLoader size={20} color={swarm_yellow}></GridLoader>}
			</div>
		</div>
	);
}

export default LoadingSpinner;
